class InterviewListSlider {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length || typeof Swiper === 'undefined') return;

    this.minSlides = 4;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.canHover = window.matchMedia('(hover: hover)').matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');

    this.items = Array.from(this.roots)
      .map((root) => {
        const viewport = root.querySelector('.c-interview-list__viewport');
        const slides = Array.from(root.querySelectorAll('.swiper-slide'));
        return {
          root,
          viewport,
          slides,
          pagination: root.querySelector('.c-interview-list__pagination'),
          count: slides.length,
          swiper: null,
        };
      })
      .filter((item) => item.viewport && item.count >= this.minSlides);

    this.resizeQueued = false;
    this.spQuery.addEventListener('change', () => this.update());
    window.addEventListener('resize', () => {
      if (this.resizeQueued) return;
      this.resizeQueued = true;
      window.requestAnimationFrame(() => {
        this.resizeQueued = false;
        this.updateSpace();
      });
    });
    this.update();
  }

  spaceBetween() {
    const rem = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    if (Number.isNaN(rem)) {
      return this.spQuery.matches ? 24 : 50;
    }
    return this.spQuery.matches ? rem * 2.4 : rem * 5;
  }

  update() {
    this.items.forEach((item) => {
      if (item.swiper) {
        item.swiper.destroy(true, true);
        item.swiper = null;
      }
      item.swiper = new Swiper(item.viewport, this.options(item));
    });
  }

  updateSpace() {
    const space = this.spaceBetween();
    this.items.forEach((item) => {
      if (!item.swiper) return;
      item.swiper.params.spaceBetween = space;
      item.swiper.update();
    });
  }

  options(item) {
    const isSp = this.spQuery.matches;
    const canSlide = item.count > (isSp ? 1 : 3);

    return {
      // SP: カード幅は CSS の 30rem。auto + 中央寄せで左右 2.4rem すきまの隣カードを覗かせる
      slidesPerView: isSp ? 'auto' : 3,
      centeredSlides: isSp,
      spaceBetween: this.spaceBetween(),
      speed: this.reduceMotion ? 0 : 600,
      loop: true,
      loopAddBlankSlides: false,
      watchOverflow: true,
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      allowTouchMove: canSlide,
      grabCursor: canSlide && this.canHover,
      observer: true,
      observeParents: true,
      pagination: {
        el: item.pagination,
        clickable: true,
        bulletClass: 'c-interview-list__pagination-bullet',
        bulletActiveClass: 'is-active',
      },
      a11y: {
        enabled: true,
        slideRole: null,
        paginationBulletMessage: '{{index}}番目へ',
      },
    };
  }
}
